<div class="flex--row print-border-all table-header">
  <div
    class="flex__child flex__child-3 table-header print-padding align-desktop-top align-print-center text--bold"
  >
    {{ 'usageStandardsTotalInKg' | translate }}
  </div>
  <div
    class="flex__child flex__child-1 table-header text--center print-padding-vertical align-desktop-top align-print-center text--bold"
  >
    {{ 'hectares' | translate }}
  </div>
  <div class="flex__child flex__child-4">
    <div class="flex--row">
      <div class="flex__child flex__child-1 table-header text--center print-border-left">
        <div class="print-border-bottom print-padding-vertical text--bold">
          {{ 'nFertilizer' | translate }}
        </div>
        <div class="flex--row flex--nowrap">
          <div class="flex__child flex__child-1 text--center text--label print-padding text--bold">
            {{ 'standard' | translate }}
          </div>
          <div
            class="flex__child flex__child-1 text--center text--label print-padding print-border-left text--bold"
          >
            {{ 'usage' | translate }}
          </div>
        </div>
      </div>
      <div class="flex__child flex__child-1 table-header text--center print-border-left">
        <div class="print-border-bottom print-padding-vertical text--bold">
          {{ 'phosphate' | translate }}
        </div>
        <div class="flex--row flex--nowrap">
          <div class="flex__child flex__child-1 text--center text--label print-padding text--bold">
            {{ 'standard' | translate }}
          </div>
          <div
            class="flex__child flex__child-1 text--center text--label print-padding print-border-left text--bold"
          >
            {{ 'usage' | translate }}
          </div>
        </div>
      </div>
      <div class="flex__child flex__child-1 table-header text--center print-border-left">
        <div class="print-border-bottom print-padding-vertical text--bold">
          {{ 'nTotal' | translate }}
        </div>
        <div class="flex--row flex--nowrap">
          <div class="flex__child flex__child-1 text--center text--label print-padding text--bold">
            {{ 'standard' | translate }}
          </div>
          <div
            class="flex__child flex__child-1 text--center text--label print-padding print-border-left text--bold"
          >
            {{ 'usage' | translate }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="flex--row print-border-no-top" data-test="fertilization-legal-standards-balance">
  <div
    class="flex__child flex__child-3 print-padding-horizontal text--bold"
    style="align-self: center"
  >
    {{ 'total' | translate }}
  </div>
  @if (legalStandardBalance) {
    <div
      class="flex__child flex__child-1 text--center"
      style="align-self: center"
      data-test="fertilization-legal-standards-balance__hectares"
    >
      {{ legalStandardBalance.areaInHectares | agrNumber: '1.2-2' }}
    </div>
    <div class="flex__child flex__child-4">
      <div class="flex--row">
        <div class="flex__child flex__child-1 flex--row text--center print-border-left">
          <div
            class="flex__child flex__child-1 text--center print-padding"
            data-test="fertilization-legal-standards-balance__nManureLegalStandard"
          >
            {{ legalStandardBalance.nManureLegalStandard | agrNumber: '1.0-0' }}
          </div>
          <div
            class="flex__child flex__child-1 text--center print-padding print-border-left"
            data-test="fertilization-legal-standards-balance__nManureUsage"
          >
            {{ legalStandardBalance.nManureUsage | agrNumber: '1.0-0' }}
          </div>
        </div>
        <div class="flex__child flex__child-1 flex--row text--center print-border-left">
          <div
            class="flex__child flex__child-1 text--center print-padding"
            data-test="fertilization-legal-standards-balance__p2O5LegalStandard"
          >
            {{ legalStandardBalance.p2O5LegalStandard | agrNumber: '1.0-0' }}
          </div>
          <div
            class="flex__child flex__child-1 text--center print-padding print-border-left"
            data-test="fertilization-legal-standards-balance__p2O5Usage"
          >
            {{ legalStandardBalance.p2O5Usage | agrNumber: '1.0-0' }}
          </div>
        </div>
        <div class="flex__child flex__child-1 flex--row text--center print-border-left">
          <div
            class="flex__child flex__child-1 text--center print-padding"
            data-test="fertilization-legal-standards-balance__nTotalLegalStanard"
          >
            {{ legalStandardBalance.nTotalLegalStandard | agrNumber: '1.0-0' }}
          </div>
          <div
            class="flex__child flex__child-1 text--center print-padding print-border-left"
            data-test="fertilization-legal-standards-balance__nTotalUsage"
          >
            {{ legalStandardBalance.nTotalUsage | agrNumber: '1.0-0' }}
          </div>
        </div>
      </div>
      <div class="flex--row print-border-top">
        <div class="flex__child flex__child-1 text--center print-border-left">
          <div class="print-border-bottom print-padding-vertical text--label">
            <strong>{{ 'balance' | translate }}</strong>
          </div>
          <div
            class="print-padding-vertical"
            data-test="fertilization-legal-standards-balance__nManureBalance"
          >
            {{ legalStandardBalance.nManureBalance | agrNumber: '1.0-0' }}
          </div>
        </div>
        <div class="flex__child flex__child-1 text--center print-border-left">
          <div class="print-border-bottom print-padding-vertical text--label">
            <strong>{{ 'balance' | translate }}</strong>
          </div>
          <div
            class="print-padding-vertical"
            data-test="fertilization-legal-standards-balance__p2O5Balance"
          >
            {{ legalStandardBalance.p2O5Balance | agrNumber: '1.0-0' }}
          </div>
        </div>
        <div class="flex__child flex__child-1 text--center print-border-left">
          <div class="print-border-bottom print-padding-vertical text--label">
            <strong>{{ 'balance' | translate }}</strong>
          </div>
          <div
            class="print-padding-vertical"
            data-test="fertilization-legal-standards-balance__nTotalBalance"
          >
            {{ legalStandardBalance.nTotalBalance | agrNumber: '1.0-0' }}
          </div>
        </div>
      </div>
    </div>
  }
</div>
